import { isEmpty } from 'lodash'

export const KEYCLOAK_SESSION = 'KEYCLOAK_SESSION'

function setKeycloakSession(state, keycloakSession) {
  return {
    type: KEYCLOAK_SESSION,
    keycloakSession
  }
}

export const initKeycloakSession = (keycloakSession) => (dispatch, getState) => {
  const state = getState()
  if (!isEmpty(state.keycloakSession)) {
    return null
  } else {
    dispatch(setKeycloakSession(state, keycloakSession))
  }
}

export const getKeycloakSession = () => (dispatch, getState) => {
  const state = getState()
  return state.keycloakSession
}



// WEBPACK FOOTER //
// ./src/actions/keycloak-actions.js